import { Box, FormControlLabel, Stack, Switch, Tooltip, Typography } from "@mui/material";
import { useState } from "react";

import AppButton from "@/common/components/Button/AppButton";
import AppIconButton from "@/common/components/Button/AppIconButton";
import InlineCode from "@/common/components/Code/InlineCode";
import AppIcon from "@/common/components/Icons/AppIcon";
import AppLink from "@/common/components/Link/AppLink";
import AppTooltip from "@/common/components/Tooltip/AppTooltip";

export function DevTooltips() {
  const [isEnabled, setIsEnabled] = useState(true);
  const [isOpen, setIsOpen] = useState<boolean | undefined>(undefined);

  return (
    <Stack spacing={4}>
      <Typography component='div' variant='h4'>
        Tooltips
      </Typography>

      <Box>
        <FormControlLabel
          control={<Switch checked={isEnabled} onChange={(e) => setIsEnabled(e.target.checked)} />}
          label='Enabled'
        />
        <FormControlLabel
          control={
            <Switch
              checked={isOpen ?? false}
              onChange={(e) => setIsOpen(e.target.checked ? true : undefined)}
            />
          }
          label={`Open (refresh page if doesn't work)`}
        />
      </Box>

      <Stack spacing={1}>
        <Typography component='div' variant='h5'>
          <InlineCode>MUI Tooltip</InlineCode>
        </Typography>
        <Stack gap={1} alignItems='flex-start'>
          <AppLink to='https://mui.com/material-ui/react-tooltip/'>MUI docs</AppLink>

          <Stack key={(isOpen ?? false).toString()} direction='column' gap={4}>
            <Tooltip
              open={isOpen}
              title='Lorem ipsum, dolor sit amet consectetur adipisicing elit.'
            >
              <AppIconButton>
                <AppIcon of='info' />
              </AppIconButton>
            </Tooltip>

            <Tooltip
              open={isOpen}
              title='Lorem ipsum, dolor sit amet consectetur adipisicing elit.'
            >
              <AppButton variant='contained'>Help!</AppButton>
            </Tooltip>
          </Stack>
        </Stack>
      </Stack>

      <Stack spacing={1}>
        <Typography component='div' variant='h5'>
          <InlineCode>AppTooltip</InlineCode> (based on MUI Tooltip)
        </Typography>
        <Stack gap={1} alignItems='flex-start'>
          <Stack key={(isOpen ?? false).toString()} direction='column' gap={4}>
            <AppTooltip
              isEnabled={isEnabled}
              open={isOpen}
              title='Lorem ipsum, dolor sit amet consectetur adipisicing elit.'
            >
              <AppIconButton>
                <AppIcon of='info' />
              </AppIconButton>
            </AppTooltip>

            <AppTooltip
              isEnabled={isEnabled}
              open={isOpen}
              title='Lorem ipsum, dolor sit amet consectetur adipisicing elit.'
            >
              <AppButton variant='contained'>Help!</AppButton>
            </AppTooltip>
          </Stack>
        </Stack>
      </Stack>
    </Stack>
  );
}
